import moment from "moment";

export class DateUtils {
    static getCurrentYearStartDate = () => {
        return moment(new Date(new Date().getFullYear(), 0, 1)).format('YYYY-MM-DD')
    }

    static getDate = () => {
        return moment(new Date()).format('YYYY-MM-DD')
    }
}

